import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { usePermissions } from './PermissionsProvider';

/** Route guard: renders children only when the user holds `permission`. */
const RequirePermission = ({ permission, children }) => {
  const { can, loading } = usePermissions();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!can(permission)) {
    return (
      <Box sx={{ textAlign: 'center', py: 8, color: 'text.secondary' }}>
        <LockOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h6">You don't have access to this page</Typography>
        <Typography variant="body2">Ask an administrator to grant you the required role.</Typography>
      </Box>
    );
  }

  return children;
};

export default RequirePermission;
